module.exports = __webpack_public_path__ + "img/perforaciones_3-4.026ab023.webp";